<template>
  <span>
    <button class="btn btn-warning" type="button" data-toggle="modal" :data-target="'#' + taskAttachmentModalId()">Add Document</button>
    <div class="modal fade" :id="taskAttachmentModalId()" ref="vuemodal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Upload a File</h5>
            <button type="button" class="close btn" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
          </button>
          </div>
          <div class="modal-body">
            <iframe border=0 ref="attachmentIframe">
              <p>Error Loading Attachments</p>
            </iframe>
          </div>
        </div>
      </div>
    </div>
  </span>
</template>

<script>
export default {
  props: ['project'],
  mounted() {
    $(this.$refs.vuemodal).on("show.bs.modal", this.loadAttachmentIframe)
  },
  methods: {
    taskAttachmentModalId(){
      return 'task-attachment-modal-new'
    },
    loadAttachmentIframe(){
      this.$refs.attachmentIframe.src = this.taskAttachmentUrl();
    },
    taskAttachmentUrl(){
      if(this.project){
        return '/api/tasks/new?project_id=' + this.project.id      
      } else {
        return '/api/tasks/new'        
      }
    },
  }
}
</script>
